import { useEffect, useRef } from 'react';

const CustomCursor = () => {
  const dotRef = useRef(null);
  const rafRef = useRef(null);
  const posRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMove = (e) => {
      posRef.current.x = e.clientX;
      posRef.current.y = e.clientY;
      if (!rafRef.current) {
        rafRef.current = requestAnimationFrame(() => {
          if (dotRef.current) {
            const { x, y } = posRef.current;
            dotRef.current.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
          }
          rafRef.current = null;
        });
      }
    };

    const handleTouchMove = (e) => {
      if (!e.touches || e.touches.length === 0) return;
      const t = e.touches[0];
      posRef.current.x = t.clientX;
      posRef.current.y = t.clientY;
      if (!rafRef.current) {
        rafRef.current = requestAnimationFrame(() => {
          if (dotRef.current) {
            const { x, y } = posRef.current;
            dotRef.current.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
          }
          rafRef.current = null;
        });
      }
    };

    window.addEventListener('mousemove', handleMove, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: true });
    // If this is a touch device, set an initial random position so the dot
    // does not sit at the top-left (0,0) before any touch events occur.
    const isTouch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    if (isTouch && dotRef.current) {
      const rx = Math.max(8, Math.floor(Math.random() * window.innerWidth));
      const ry = Math.max(8, Math.floor(Math.random() * window.innerHeight));
      posRef.current.x = rx;
      posRef.current.y = ry;
      dotRef.current.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
    }

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('touchmove', handleTouchMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return <div ref={dotRef} className="stockDot customCursor" />;
};

export default CustomCursor;
